import type { Company } from '@/types/Company';
import type { GetCompanyListResponseDTO } from '@/core/dto/company';

export class GetCompaniesMapper {
	constructor(private readonly data: GetCompanyListResponseDTO) {}

	toDomain(): Company[] {
		return this.data.map((value) => ({ id: value.id, name: value.name }));
	}
}
